import { action, observable } from "mobx";
import NestStore from "~/stores/NestStore";
import InvoicePaymentRepository from "~/repository/Invoice/InvoicePaymentRepository";

class InvoicePaymentStore extends NestStore {
  /**
   * @property {InvoicePayment}
   */
  @observable invoicePayment;

  invoicePaymentRepository = null;

  constructor() {
    super();

    this.invoicePaymentRepository = new InvoicePaymentRepository();
  }

  @action
  create(data) {
    this.isSaving = true;

    return this.invoicePaymentRepository
      .create(data)
      .catch(e => {
        this.isSaving = false;
        this.setErrorMessages(e);
        throw e;
      })
      .finally(() => {
        this.isSaving = false;
      });
  }
}

export default InvoicePaymentStore;
